
import React, { useEffect } from 'react';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';

import OperationStatus from '../common/client/components/OperationStatus';
import useKeepConnection from '../common/client/hooks/useKeepConnection';

import Routes from '../common/client/components/Routes';
import usePageTracking from './usePageTracking';

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/');

const App = (props) => {

    useEffect(() => {
        // nop
    }, []);

    usePageTracking();
    useKeepConnection([
        '/api/?{TICK}',
        '/app/health?{TICK}'
    ]);
    return (
        <>
            <Routes routes={props.routes} />
            <OperationStatus />
        </>
    );
};

export default App;
